var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 263,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 478.29 245.03)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -268.42 112.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-331.58, -562.53)",
    d: "M 325.10061 540.37506 a 10.22114 10.22114 0 0 0 -10.20953 10.20973 v 23.88568 a 10.22114 10.22114 0 0 0 10.20953 10.20973 h 12.94974 a 10.22114 10.22114 0 0 0 10.20953 -10.20973 V 550.58479 a 10.22114 10.22114 0 0 0 -10.20953 -10.20973 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -41.99 112.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-558.01, -562.53)",
    d: "M 564.48154 585.4747 H 551.53181 a 11.01656 11.01656 0 0 1 -11.004 -11.00423 V 550.58479 a 11.01656 11.01656 0 0 1 11.004 -11.00423 h 12.94973 a 11.01655 11.01655 0 0 1 11.004 11.00423 v 23.88568 A 11.01655 11.01655 0 0 1 564.48154 585.4747 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.61 82.41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-444.39, -532.41)",
    d: "M 555.88912 566.35017 H 332.89854 c -10.14844 0 -18.40471 -5.98277 -18.40471 -13.33651 V 510.1338 l 11.06824 -11.65635 H 565.37864 l 8.91519 11.68079 v 42.85542 C 574.29383 560.3674 566.03756 566.35017 555.88912 566.35017 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -154.41 38.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-445.59, -488.55)",
    d: "M 564.338 519.92883 H 326.83353 L 324.42 482.92 l 1.53584 -3.787 l 8.9276 -21.96927 H 554.6805 l 12.07144 24.94747 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.66 44.56)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "27.01,-12.37 25.24,15.44 -27.01,15.44 -27.01,-5.22 25.53,-15.44 27.01,-12.37 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -248.56 44.64)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "26.62,-5.3 26.62,15.36 -24.85,15.36 -26.62,-11.66 -25.11,-15.36 26.62,-5.3 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.22 -31.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-444.78, -418.69)",
    d: "M 553.35569 463.51965 h -217.15 l 23.16063 -77.20183 a 15.4952 15.4952 0 0 1 14.76295 -11.09345 l 143.811 -1.36981 a 15.56437 15.56437 0 0 1 15.219 11.6645 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.22 -23.83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-444.78, -426.17)",
    d: "M 536.63916 456.21966 L 352.887 454.04078 a 1.48477 1.48477 0 0 1 -1.39631 -1.93785 l 17.61552 -54.96041 a 1.48476 1.48476 0 0 1 1.41392 -1.03159 H 518.31576 a 1.48476 1.48476 0 0 1 1.41372 1.031 l 18.341 57.1393 A 1.48477 1.48477 0 0 1 536.63916 456.21966 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.22 -73.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(66,133,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-444.78, -376.13)",
    d: "M 469.54471 383.27562 h -49.528 c -0.41737 0 -0.79594 -0.41083 -0.98795 -1.07265 a 3.33948 3.33948 0 0 1 0.07889 -2.05917 l 4.08423 -10.32844 c 0.2082 -0.52643 0.54809 -0.84066 0.90906 -0.84066 h 41.35956 c 0.361 0 0.70086 0.31423 0.90906 0.84066 l 4.08423 10.32844 a 3.33948 3.33948 0 0 1 0.07889 2.05917 C 470.34065 382.86479 469.96208 383.27562 469.54471 383.27562 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -279.94 3.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-320.06, -453.99)",
    d: "M 336.34245 461.93066 H 303.76814 v -7.15977 a 8.73991 8.73991 0 0 1 8.73014 -8.73014 h 23.84417 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.47 3.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-569.53, -453.99)",
    d: "M 585.814 461.93066 H 553.2397 V 446.04075 h 23.84417 a 8.7399 8.7399 0 0 1 8.73014 8.73014 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94 -0.34 0.34 0.94 -379.33 153.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -84.60525,
    y: -0.99979,
    rx: 0,
    ry: 0,
    width: 169.2105,
    height: 1.99958
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.34 -0.94 0.94 0.34 67.91 153.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.99975,
    y: -84.60519,
    rx: 0,
    ry: 0,
    width: 1.9995,
    height: 169.21038
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.13 146.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-448.87, -596.56)",
    d: "M 453.63975 615.0253 h -9.532 V 602.71366 h 9.532 Z m 0 -24.6242 h -9.532 V 578.08945 h 9.532 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.13 197.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-448.87, -647.56)",
    d: "M 453.63975 666.0253 h -9.532 V 653.71366 h 9.532 Z m 0 -24.6242 h -9.532 V 629.08945 h 9.532 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 264.72 153.25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "7.75,20.25 -2.75,20.25 -7.75,-20.25 7.75,-20.25 7.75,20.25 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 258.22 176.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-858.22, -626.87)",
    d: "M 875.14472 633.67228 H 841.294 v -0.42816 A 13.19085 13.19085 0 0 1 854.47 620.06826 h 20.67468 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 390.78 138.95)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "17.07,14.65 8.07,20.06 -17.07,-12.08 -3.79,-20.06 17.07,14.65 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 399.83 163.83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-999.83, -613.83)",
    d: "M 986.36647 628.38052 l -0.22056 -0.36711 a 13.19131 13.19131 0 0 1 4.50819 -18.08 l 17.72211 -10.64748 l 7.00626 11.661 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 328.25 78.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-928.25, -528.2)",
    d: "M 875.19656 615.13943 l -0.181 -0.00084 a 140.97355 140.97355 0 0 1 -15.28467 -0.87972 c -1.93444 -0.19109 -4.03279 -0.39847 -6.561 -0.60586 l -0.08676 -0.01631 c -1.725 -0.51262 -1.77284 -16.69018 -1.04155 -72.06545 c 0.37464 -28.3629 0.799 -60.50938 0.29373 -80.9819 l -0.005 -0.20112 l 0.152 -0.13254 c 18.72728 -16.28837 42.77725 -22.39421 67.7197 -17.19235 l 0.185 0.03847 l 0.09617 0.16265 c 10.31779 17.45785 25.89639 42.60456 40.962 66.9238 c 34.58414 55.826 44.47545 72.2444 43.39126 73.48288 l -0.13066 0.10118 c -2.36156 1.18078 -4.13461 2.08978 -5.64215 2.86289 c -5.04778 2.58817 -7.13713 3.6594 -18.36309 8.28216 l -0.27721 0.11415 l -0.20216 -0.22161 c -35.09112 -38.45219 -64.29319 -81.40546 -82.35585 -121.11285 c -2.11069 13.55594 -4.67252 31.25714 -7.37944 49.96017 c -7.784 53.78221 -13.04479 89.19675 -15.16258 91.353 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 304.57 -188.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-904.57, -261.43)",
    d: "M 929.6997 288.87763 c 3.53406 -14.59194 6.52817 -31.05011 -0.13679 -44.48948 c -4.62448 -9.32489 -21.73208 -12.4651 -31.53891 -9.10571 s -16.8972 12.47368 -20.01555 22.41111 s -2.756 20.64575 -1.39688 30.9764 C 894.64766 288.32348 912.68376 287.977 929.6997 288.87763 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 299.26 -182.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 21.03196
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 298.56 -199.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-898.56, -250.41)",
    d: "M 924.97464 263.50924 a 26.41687 26.41687 0 1 0 -52.802 0.69608 C 890.17443 264.24354 908.17621 264.28176 924.97464 263.50924 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 294.24 -66.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-894.24, -383.92)",
    d: "M 884.65135 464.72625 a 183.81143 183.81143 0 0 1 61.46354 10.2904 c 0.6876 -33.1529 -10.7263 -66.36727 -31.36355 -91.215 l -0.15429 -0.18565 l 0.079 -0.22787 c 5.51231 -15.92753 11.20985 -32.39067 16.30091 -48.77228 l -0.07715 -0.27513 c -3.57055 -12.69377 -11.23452 -25.52092 -23.42926 -39.21526 a 7.5049 7.5049 0 0 0 -10.24483 -0.51889 c -21.67608 19.87084 -33.46211 49.64365 -30.75832 77.70048 l 0.00794 0.08237 l -0.02362 0.07986 c -9.54887 32.35053 -13.01531 48.96671 -16.07367 63.62691 c -2.23089 10.69431 -4.16261 19.95446 -8.0409 33.18552 A 199.25259 199.25259 0 0 1 884.65135 464.72625 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 291.05 -53.72)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "24.4,-33.81 -6.66,33.81 -24.41,15.85 24.4,-33.81 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 241.49 -35.15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-841.49, -414.85)",
    d: "M 845.7319 400.02472 l 2.16588 4.20837 a 0.16551 0.16551 0 0 1 -0.07119 0.22226 l -0.10444 0.05374 L 859.00492 426.432 a 2.57275 2.57275 0 0 1 -1.11023 3.4647 l -13.6984 7.05 a 2.57216 2.57216 0 0 1 -3.464 -1.11036 l -0.00009 -0.00017 l -10.88707 -21.154 l -0.07562 0.03891 a 0.11654 0.11654 0 0 1 -0.15688 -0.04973 L 828.38 412.27622 a 0.11669 0.11669 0 0 1 0.05035 -0.1572 l 0 0 l 0.07561 -0.03892 l -0.46431 -0.90215 l -0.07625 0.03925 a 0.12226 0.12226 0 0 1 -0.16435 -0.0532 l -1.21582 -2.36241 a 0.12207 0.12207 0 0 1 0.05257 -0.164 l 0.07625 -0.03925 l -0.63382 -1.2315 l -0.07752 0.03989 a 0.108 0.108 0 0 1 -0.14547 -0.04637 l -0.00013 -0.00028 l -0.66346 -1.28917 a 0.10856 0.10856 0 0 1 0.0463 -0.14622 l 0.07753 -0.03991 l -1.34345 -2.61039 a 2.572 2.572 0 0 1 1.10989 -3.46373 l 13.6984 -7.05 a 2.5726 2.5726 0 0 1 3.46438 1.10956 l 3.15845 6.137 l 0.10445 -0.05373 A 0.16545 0.16545 0 0 1 845.7319 400.02472 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 241.69 -34.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(66,133,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-841.69, -415.16)",
    d: "M 841.3842 394.88633 l 16.623 32.29907 a 1.63223 1.63223 0 0 1 -0.70469 2.19755 l -13.11277 6.74856 a 1.6294 1.6294 0 0 1 -2.19562 -0.69932 l -0.00225 -0.00441 l -16.62295 -32.29907 a 1.63213 1.63213 0 0 1 0.70423 -2.19813 l 0.00012 -0.00006 l 1.96256 -1.01006 l 0.12959 0.25182 a 1.34394 1.34394 0 0 0 1.81 0.58 l 6.66885 -3.43216 a 1.344 1.344 0 0 0 0.58 -1.81 l -0.12958 -0.25181 l 2.09138 -1.07634 a 1.6317 1.6317 0 0 1 2.19774 0.70337 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 258.22 -32.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-858.22, -417.48)",
    d: "M 846.20208 434.34586 a 8.61088 8.61088 0 0 0 7.75389 -10.68725 l 25.5958 -16.76992 l -14.59752 -6.30634 L 842.886 417.47419 a 8.65757 8.65757 0 0 0 3.31608 16.87167 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 284.64 -91.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-884.64, -358.65)",
    d: "M 870.831 422.26469 l -0.32279 -0.2283 c -6.09162 -4.48352 -12.85433 -9.12008 -19.39439 -13.604 l -0.39283 -0.26927 l 0.30941 -0.36209 c 13.959 -16.33186 27.93307 -33.39082 41.4495 -49.89327 c -0.01045 -0.02634 -0.019 -0.04557 -0.02592 -0.05937 l 0.12732 -0.06481 l 0.05393 -0.06565 l 0.02885 0.02384 l 0.08154 -0.0414 l -0.36837 0.02843 l -4.166 -32.67039 c -3.76289 -5.13329 -4.48352 -15.325 0.448 -22.43936 c 5.10778 -7.36982 15.91394 -9.83633 23.12613 -5.28047 a 15.175 15.175 0 0 1 6.66361 11.33237 a 13.68617 13.68617 0 0 1 -3.62784 11.20693 c 1.77075 17.28977 1.83849 32.744 1.90434 47.69268 l 0.00063 0.14927 l -0.09241 0.12293 C 902.2244 386.149 886.39659 404.35777 871.09 421.967 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.5 -164.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(66,133,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 47.28997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.59 -164.19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-8.42,19.94 -22.57,1.74 -14.34,-4.66 -7.64,3.96 15,-19.94 22.57,-12.77 -8.42,19.94 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 338.79 183.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-938.79, -633.97)",
    d: "M 1058.29108 634.9747 h -239 a 1 1 0 0 1 0 -2 h 239 a 1 1 0 0 1 0 2 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.461a2dd5d45fc50ceaa4bed513d69f36.svg";
export { ForwardRef as ReactComponent };